// utils/spotifyAuth.js
import pkceChallenge from 'pkce-challenge';
import { redirect_uri } from '.';

const CLIENT_ID = 'cbd536439be2450aa0709cb1c39ffcba';
const REDIRECT_URI = redirect_uri();

// const REDIRECT_URI = 'http://127.0.0.1:8000/callback';
const REDIRECT_uri =  `${REDIRECT_URI}callback` ;
const SCOPES = [
  'user-read-private',
  'user-read-email',
  'playlist-read-private',
  'user-top-read',
].join(' ');

// Create PKCE challenge and save verifier
export const redirectToSpotifyAuth = async () => {
  const { code_challenge, code_verifier } = await pkceChallenge();

  localStorage.setItem('verifier', code_verifier);

  const authUrl = new URL('https://accounts.spotify.com/authorize');
  authUrl.searchParams.append('client_id', CLIENT_ID);
  authUrl.searchParams.append('response_type', 'code');
  authUrl.searchParams.append('redirect_uri', REDIRECT_uri);
  authUrl.searchParams.append('scope', SCOPES);
  authUrl.searchParams.append('code_challenge_method', 'S256');
  authUrl.searchParams.append('code_challenge', code_challenge);

  window.location.href = authUrl.toString();
};